import "./Account.css";

interface Props {
  onclick?: () => void,
  heading?: string,
  text?: string,
  handleClick?: () => void,
  buttonTxt1?: string,
  buttonTxt2?: string,
  imgPath?: string
  backIteration?: boolean
}

const ForgetPasswordPopup = (prop: Props) => {
  return (
    <div className='passwordPopup'>
      <div className="popupWrap">
        <button className='closeBtn btnNoStyle' onClick={prop.onclick}>
          <img src={prop.backIteration ? './../../assets/images/cross-s.png' : './assets/images/cross-s.png'} alt="Cross Button" />
        </button>
        <div className="img">
          <img src={prop.backIteration ? `./../../assets/images/reset.png` : `./assets/images/reset.png`} alt="" />
        </div>
        <div className="titleBlock">
          <h2>{prop.heading} </h2>
          <p>{prop.text}</p>
        </div>
        <div className='bottomBlock d-flex justify-content-center'>
          {prop.buttonTxt1 && <button className='lightBlueBtn' type="submit" onClick={prop.handleClick} >{prop.buttonTxt1}</button>}
          {prop.buttonTxt2 && <button className='blueBorderBtn' type="submit" onClick={prop.onclick}>{prop.buttonTxt2}</button>}
        </div>
      </div>
    </div>
  )
}

export default ForgetPasswordPopup;